export * from './abschnitt-delete-request.interface';
export * from './abschnitt-delete-response.interface';
export * from './abschnitt-delete.shapes';
